import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';

import {
	Visibility,
	FilterList,
	ConfirmationNumber,
	Close,
} from '@material-ui/icons';

import { withLocalize } from 'react-localize-redux';

import {
	Button,
	IconButton,
	Paper,
	Typography,
	Toolbar,
	Box,
	Dialog,
	DialogActions,
	DialogContent,
	DialogContentText,
	DialogTitle,
	AppBar,
	FormControl,
	InputLabel,
	MenuItem,
	Select,
	Chip,
	LinearProgress,
	CircularProgress,
	Grid,
	Link,
	Slide,
	Input,
	TextField
} from '@material-ui/core';

import Format from 'date-fns/format';

import { MuiPickersUtilsProvider, DatePicker } from '@material-ui/pickers';

import { useHistory } from 'react-router-dom';

import MUIDataTable from 'mui-datatables';

import { useSnackbar } from 'notistack';

import {
	FinanceService,
} from '../../../../../utils/web_config_2';

import {
	AdminService,
	ReportingService,
	Validator,
	Permissions,
} from "../../../../../utils/web_config";


import DateFnsUtils from '@date-io/date-fns';

import axios from 'axios';

import Chart from 'react-apexcharts';

import Skeleton from '@material-ui/lab/Skeleton';
import { set } from 'date-fns';

const Transition = React.forwardRef(function Transition(props, ref) {
	return <Slide direction='up' ref={ref} {...props} />;
});

const useStyles1 = makeStyles((theme) => ({
	root: {
		flexShrink: 0,
		flexFlow: 1,
		[theme.breakpoints.up('sm')]: {
			marginLeft: 250,
		},
	},
	btn: {
		textTransform: 'capitalize',
	},
	formTitle: {
		flexGrow: 1,
	},
	paper: {
		padding: theme.spacing(2),
		textAlign: 'center',
		color: theme.palette.text.secondary,
		height: 300,
		elevation: 0,
	},
	appBar: {
		position: 'relative',
	},
	title: {
		marginLeft: theme.spacing(2),
		flex: 1,
	},
}));

function CheckServiceFee() {
	const classes = useStyles1();

	const [operatorData, setOperatorData] = useState({});

	const { enqueueSnackbar, closeSnackbar } = useSnackbar();

	const [reportsMessage, setReportsMessage] = useState('No data available');
	const [reportTitle, setReportTitle] = useState('Improved Service Fee Report');

	const columns = [
		{
			name: 'service_fee',
			label: 'Service Fee',
			options: {
				filter: false,
				sort: true,
			},
		},
		{
			name: 'total_sales',
			label: 'Sales',
			options: {
				filter: false,
				sort: true,
			},
		},
		{
			name: 'status',
			label: 'Status',
			options: {
				filter: true,
				sort: true,
			},
		}
	];


	const options = {
		textLabels: {
			body: {
				noMatch: reportsMessage,
			},
		},
		filterType: 'checkbox',
		download: true,
		responsive: 'standard',
		selectableRows: false,
		rowsPerPage: 10,
		elevation: 0,
		customToolbarSelect: (selectedRows, displayData, setSelectedRows) => (
			<Box>
				<Chip
					className={classes.chip}
					icon={<Visibility />}
					color='primary'
					variant='outlined'
					label='View details'
					onClick={() => {
						var id = displayData[selectedRows.data[0]['index']]['data'][0];
						console.log('ticket id', id);
					}}
				/>
			</Box>
		),
	};

	useEffect(() => {
		var data = {};

		var data = new AdminService().accountData;
		setOperatorData(data);
	}, []);

	const [amounts, setAmounts] = useState([]);
	const [labels, setLabels] = useState([]);

	const [revenue, setRevenue] = useState([]);

	const [currency, setCurrency] = useState('');

	const pos_performance = {
		options: {
			series: [],
			chart: {
				width: 380,
				type: 'pie',
			},

			labels: labels,
			legend: {
				position: 'right',
				itemMargin: {
					horizontal: 0,
				},
			},
			responsive: [
				{
					breakpoint: 480,
					options: {
						chart: {
							width: 280,
							height: 280,
						},
						legend: {
							position: 'right',
						},
					},
				},
			],
		},
	};

	// fee revenue

	const revenue_fee = {
		options: {
			series: [
				{
					name: 'Revenue',
					data: revenue,
				},
			],
			chart: {
				height: 350,
				type: 'bar',
				tools: {
					download: false,
					selection: false,
					pan: false,
					reset: false,
				},
			},
			plotOptions: {
				bar: {
					horizontal: false,
					distributed: false,
					startingShape: 'flat',
					columnWidth: '5px',
					dataLabels: {
						enabled: false,
					},
				},
			},
			dataLabels: {
				enabled: false,
				formatter: function (val) {
					return formatMoney(parseInt(val), 0) + ' ';
				},
				offsetY: -20,
				style: {
					fontSize: '12px',
					colors: ['#304758'],
				},
			},

			xaxis: {
				categories: labels,
				position: 'bottom',
				axisBorder: {
					show: false,
				},
				axisTicks: {
					show: false,
				},
				crosshairs: {
					fill: {
						type: 'gradient',
						gradient: {
							colorFrom: '#D8E3F0',
							colorTo: '#BED1E6',
							stops: [0, 100],
							opacityFrom: 0.4,
							opacityTo: 0.5,
						},
					},
				},
				tooltip: {
					enabled: true,
				},
			},
			yaxis: {
				axisBorder: {
					show: false,
				},
				axisTicks: {
					show: false,
				},
				labels: {
					show: false,
					formatter: function (val) {
						return val + ' ';
					},
				},
			},
		},
	};


	const [reportLoad, setReportLoad] = useState(false);
	const [reports, setReports] = useState([]);



	// filter report

	// filter dialog
	const [filterDialog, setFilterDialog] = useState(false);
	const [username,setUsername]=useState({value:'',error:''});

	const filter_report = () => {
		setReportLoad(true);
		setReports([]);

		var data = {};

		data = {
			username: username.value
		};

		axios.defaults.baseURL = new FinanceService().BASE_URL;
		const reportInstance = axios.create(
			new FinanceService().setHeaders(operatorData.token)
		);
		reportInstance
			.get('/api/v1/getMemberServiceFeeHistory', {
				params: data,
			})
			.then((res) => {
				const objs = res.data.data;
				console.log('===== report =====', objs);
				if (objs.length === 0) {
					setReportsMessage('No service fee report available today');
				} else {
					setReports(objs);
				}
				setReportLoad(false);
				setFilterDialog(false);
			})
			.catch((err) => {
				setReportLoad(false);
				if (err.response) {
					enqueueSnackbar(err.response.data.message, {
						variant: 'error',
					});
				}

				if (err.message) {
					setReportsMessage(err.message);
					enqueueSnackbar(err.message, {
						variant: 'error',
					});
				}
			});
	};


	// format money

	function formatMoney(
		amount,
		decimalCount = 2,
		decimal = '.',
		thousands = ','
	) {
		try {
			decimalCount = Math.abs(decimalCount);
			decimalCount = isNaN(decimalCount) ? 2 : decimalCount;

			const negativeSign = amount < 0 ? '-' : '';

			let i = parseInt(
				(amount = Math.abs(Number(amount) || 0).toFixed(decimalCount))
			).toString();
			let j = i.length > 3 ? i.length % 3 : 0;

			return (
				negativeSign +
				(j ? i.substr(0, j) + thousands : '') +
				i.substr(j).replace(/(\d{3})(?=\d)/g, '$1' + thousands) +
				(decimalCount
					? decimal +
					  Math.abs(amount - i)
							.toFixed(decimalCount)
							.slice(2)
					: '')
			);
		} catch (e) {
			console.log(e);
		}
	}

	return (
		<MuiPickersUtilsProvider utils={DateFnsUtils}>
			<div className={classes.root}>
				<Box display='flex'>
					<Box
						display='flex'
						alignItems='center'
						mt={2}
						className={classes.formTitle}
					>
						<Box mr={1}>
							<ConfirmationNumber fontSize='large' color='primary' />
						</Box>{' '}
						<Typography variant='h5' color='default'>
							<b>Check Service Fee</b>
						</Typography>
					</Box>

					<Button
						color='primary'
						variant='outlined'
						startIcon={<FilterList />}
						onClick={() => {
							setFilterDialog(true);
						}}
					>
						Filter
					</Button>
				</Box>

				<Box mt={2}>
					<Grid container spacing={2}>
					
						<Grid item md={12} lg={12} sm={12} xs={12}>
							{reportLoad && <LinearProgress />}
							<MUIDataTable
								title={`Service fee report ${username.value}`}
								data={reports}
								columns={columns}
								options={options}
							/>
						</Grid>
					</Grid>
				</Box>
			</div>

			{/* filter dialog  */}

			<Dialog
				maxWidth='sm'
				fullWidth
				open={filterDialog}
				onClose={() => {
					setFilterDialog(false);
				}}
				aria-labelledby='filter'
				aria-describedby='filter'
			>
				<DialogTitle id='filter'>{'Filter'}</DialogTitle>
				<DialogContent>
					<DialogContentText>
						<Box>
							<Box mt={2}>
								<TextField
									required
									size="small"
									variant="outlined"
									color="primary"
									value={username.value}
									placeholder={"Username"}
									label={"Username"}
									fullWidth
									onChange={(e)=>{
										setUsername({value:e.target.value,error:''});
									}}
								/>
							</Box>
						
						</Box>
					</DialogContentText>
				</DialogContent>

				<DialogActions>
					<Button
						onClick={() => {
							setFilterDialog(false);
						}}
						color='secondary'
						className={classes.btn}
					>
						<Typography>Close</Typography>
					</Button>

					<Button
						onClick={() => {
							filter_report();
						}}
						color='primary'
						variant='contained'
						className={classes.btn}
					>
						{reportLoad ? (
							<CircularProgress size={25} color='secondary' />
						) : (
							<Typography>View</Typography>
						)}
					</Button>
				</DialogActions>
			</Dialog>
		</MuiPickersUtilsProvider>
	);
}

export default withLocalize(CheckServiceFee);
